import { render, staticRenderFns } from "./SnapshotBreakdown.vue?vue&type=template&id=62c493c3&"
import script from "./SnapshotBreakdown.vue?vue&type=script&lang=js&"
export * from "./SnapshotBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports